// extracted by mini-css-extract-plugin
export var blue = "_1u-f";
export var brand = "_1u-b";
export var darkGrey = "_1u-e";
export var disabled = "_1u-4";
export var disabledSubtle = "_1u-5";
export var error = "_1u-6";
export var green = "_1u-g";
export var grey = "_1u-d";
export var icon = "_1u-0";
export var inherit = "_1u-a";
export var lightGrey = "_1u-c";
export var orange = "_1u-i";
export var pink = "_1u-k";
export var primary = "_1u-1";
export var purple = "_1u-l";
export var red = "_1u-j";
export var secondary = "_1u-2";
export var success = "_1u-9";
export var tertiary = "_1u-3";
export var warning = "_1u-7";
export var warningSecondary = "_1u-8";
export var white = "_1u-m";
export var yellow = "_1u-h";